<template>
    <div id="content">
        <router-link :to="$route.path.split('/').slice(0, -1).join('/')" class="back-link"><i class="bi bi-chevron-left"></i> {{ $t('plans.edit.back') }}</router-link>
        <div class="admin-card edit-card">
            <div class="admin-section-label">
                <i class="bi bi-pencil-square"></i>
                {{ $t('plans.edit.title') }}
            </div>
            <form action="" method="post" @submit.prevent="editPlan">
                <div class="form-grid">
                    <div class="form-row">
                        <label for="title" class="form-label">{{ $t('plans.edit.form.title') }}</label>
                        <input type="text" class="form-control" placeholder="free" v-model="plan.title" name="planTitle" required>
                    </div>
                    <div class="form-row">
                        <label class="form-label">{{ $t('plans.edit.form.users') }}</label>
                        <div class="form-value">
                            <span class="admin-pill admin-pill-purple">{{ plan.users || 0 }}</span>
                        </div>
                    </div>
                    <div class="form-row">
                        <label for="price" class="form-label">{{ $t('plans.edit.form.price') }}</label>
                        <input type="number" class="form-control" placeholder="₸" name="price" v-model="plan.price" required>
                    </div>
                    <div class="form-row">
                        <label for="cycle" class="form-label">{{ $t('plans.edit.form.cycle') }}</label>
                        <select class="form-select" :aria-label="$t('plans.edit.form.cyclePeriodAria')" name="cycle" v-model="plan.cycle" id="cycle" required>
                            <option v-for="option in cycles" :value="option.value">{{ option.text }}</option>
                        </select>
                    </div>
                </div>
                <div class="modules-link-row">
                    <router-link :to="`/plans/${plan.id}/modules`" class="btn-ghost">
                        <i class="bi bi-diagram-2"></i>
                        <span>{{ $t('plans.edit.moduleSettings') }}</span>
                    </router-link>
                </div>
                <div class="form-actions">
                    <button type="submit" class="btn-purple">
                        <i class="bi bi-check2"></i>
                        <span>{{ $t('plans.edit.save') }}</span>
                    </button>
                    <button type="button" class="btn-ghost" @click="$router.go(-1)">{{ $t('plans.edit.cancel') }}</button>
                    <button type="button" class="btn-danger-soft ms-auto" @click="showModal=true" :disabled="!!plan.users || plan.preventDelete">
                        <i class="bi bi-trash"></i>
                        <span>{{ $t('plans.edit.delete') }}</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
    <Modal
        v-model="showModal"
        :title="plan.title"
        :content="`<p>${$t('plans.edit.deleteConfirm')}</p>`"
        @confirm="confirmDelete"
    />
</template>

<script>
import { cycles, tsToString } from '../../../lib/utils'
import Modal from '../Modal2.vue'

export default {
    data:() => ({
        plan: {},
        cycles: cycles,
        price: 0,
        created: '',
        expiry: '',
        showModal: false
    }),
    components: {
        Modal
    },
    async mounted() {
        this.$emit('setPageTitle', this.$t('plans.edit.title'))

        await this.getPlan()
    },
    methods: {
        async getPlan() {
            let res = await this.$api.getPlan(this.$route.params.id)
            this.plan = res.data
            this.plan.created = tsToString(res.data.created)
            this.plan.expiry = tsToString(res.data.expiry)
        },
        async editPlan() {
            let response = await this.$api.editPlan(this.plan.id, this.plan)
            if(response.result === 'SUCCESS') {
                this.$router.go()
            } else {
                this.$notify({
                    text: response?.msg,
                    type: 'error'
                })
            }
        },
        async confirmDelete() {
            let response = await this.$api.deletePlan(this.plan.id)
            if(response.result === 'SUCCESS') {
                this.$router.push('/plans')
            } else {
                this.$notify({
                    text: response.msg,
                    type: response.result.toLowerCase()
                })
            }
        }
    }
}
</script>

<style scoped>
.back-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #64748b;
    font-size: 13px;
    font-weight: 500;
    text-decoration: none;
    margin-bottom: 14px;
    transition: color 0.15s ease;
}
.back-link:hover {
    color: #6d28d9;
}
.back-link i {
    font-size: 14px;
}

.edit-card {
    padding: 24px;
    max-width: 700px;
}

.form-grid {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.form-row {
    display: grid;
    grid-template-columns: 200px 1fr;
    align-items: center;
    gap: 16px;
}

.form-row .form-label {
    margin-bottom: 0;
    font-size: 13px;
    color: #64748b;
    font-weight: 500;
    text-transform: none;
    letter-spacing: 0;
}

.form-value {
    font-weight: 500;
    color: #0f172a;
    font-size: 14px;
}

.modules-link-row {
    margin-top: 18px;
}

.btn-danger-soft {
    background: #fee2e2;
    border: 1px solid #fecaca;
    color: #991b1b;
    padding: 10px 18px;
    border-radius: 10px;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.15s ease;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}
.btn-danger-soft:hover:not(:disabled) {
    background: #fecaca;
}
.btn-danger-soft:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.form-actions {
    display: flex;
    gap: 10px;
    margin-top: 24px;
    padding-top: 18px;
    border-top: 1px solid #e5e7eb;
    flex-wrap: wrap;
    align-items: center;
}

.ms-auto {
    margin-left: auto;
}
</style>
